<template>
  <base-content-page :page-title="pageTitle" :caption="pageDescription">
    <div class="d-flex justify-center">
      <logo v-if="!$vuetify.breakpoint.mobile" vertical min-height="100px" />
    </div>
    <div style="max-width: 700px" class="mx-auto">
      <v-divider class="my-5" />
      <p>
        Once you complete and submit the form, we will review it and reach out to you within 24 hours to confirm the
        information, provide a phone number, answer any additional questions you may have, and get your trial started.
        <br />
        <br />

        A couple of things to note:
      </p>

      <ul>
        <li>All our plans are month-to-month. There are no contracts to sign, and you can cancel at any time.</li>
        <li>
          At the end of your 1-week free trial period, you will receive a plan recommendation based on call volume
          during those 7 days. But you can request a specific plan if you disagree with our recommendation.
        </li>
      </ul>

      <v-divider class="my-5" />
    </div>
    <sign-up-form />
  </base-content-page>
</template>
<script>
import BaseContentPage from '@/components/BaseContentPage'
import Logo from '@/components/Logo'
import SignUpForm from '@/components/SignUpForm'

export default {
  // layout: 'empty',
  components: {
    BaseContentPage,
    SignUpForm,
    Logo
  },

  data: () => ({
    pageTitle: 'Customer Onboarding',
    pageDescription:
      'Thank you for choosing Epic Receptionists. We take your business seriously and appreciate you making us a member of your team.'
  }),

  head() {
    return {
      title: this.pageTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.pageDescription
        }
      ]
    }
  }
}
</script>

<style scoped>
.logo {
  margin: auto;
}
</style>
